"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _header = /*#__PURE__*/ _interop_require_default(require("./header"));
var _logo = require("../assets/logo");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Container, {
        px: 0,
        style: {
            maxWidth: "375px",
            height: "100%",
            backgroundColor: "#ffffff"
        },
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_header.default, {
                logo: /*#__PURE__*/ (0, _jsxruntime.jsx)(_logo.LogoCergea, {})
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)("main", {
                children: children
            })
        ]
    });
};
var _default = Layout;
